import 'css-chunksrc/client/scenes/moveFolder/folderSelection/folder/logo/styles.scss';export default {
  "logo": "_logo_1uhue_1"
};